import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* searchDiscount(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.DISCOUNTS.SEARCH_DISCOUNT, action.payload, true);
}

export function* addUpdateDiscount(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.DISCOUNTS.ADD_UPDATE_DISCOUNT, action.payload, true);
}

export function* deleteDiscount(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.DISCOUNTS.DELETE_DISCOUNT, action.payload, true);
}

